import * as awsui from "@cloudscape-design/design-tokens";
import { Navbar, Dropdown } from "@nextui-org/react"; // https://nextui.org/docs/components/navbar
import { useEffect, useState, useContext, useCallback, useRef} from "react";
import { icons } from "./icons";
import { useMediaQuery } from 'react-responsive';
import { GlobalContext } from "../../context";
import { useNavigate, useLocation, Navigate, Link } from "react-router-dom";
import { withAuthenticator, Authenticator } from '@aws-amplify/ui-react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { navigateFn } from "../../routingHelper";


export default function AccountNavLinks() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    accountContent, setAccountContent,
  } = useContext(GlobalContext);
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); 
  const { authStatus } = useAuthenticator(context => [context.authStatus]);

  const reducedNavbar = useMediaQuery({query: "only screen and (max-width : 800px)"});

  const accountLinks = [
    {label: "Profile", ref: "profile", description: "Update your profile information", disabled: false},
    // {label: "Registrations", ref: "registrations", description: "Information for the different series that you're registered for", disabled: true},
    // {label: "Team Management", ref: "team", description: "Create a team, manager your team or join a team", disabled: true},
    // {label: "Protests and Appeals", ref: "protests", description: "Protest another driver or appeal a penalty you've recieved", disabled: true},
  ]


  if (!reducedNavbar) return (
    <>
      {accountLinks.map((item) => {
        return (
          <Navbar.Link 
            css={{ 
              color: awsui.colorTextBodyDefault,
            }} 
            key={item.ref}
            isActive={accountContent === item.ref} 
            onClick={() => {
              setAccountContent(item.ref)
            }} 
          >
            {item.label}
          </Navbar.Link>
        )
      })}
    </>
  );

  return (
    <>
      <Dropdown>
        <Navbar.Item>
          <Dropdown.Button
            auto
            light
            css={{
              px: 0,
              dflex: "center",
              svg: { pe: "none" },
              color: awsui.colorTextBodyDefault,
            }}
            iconRight={icons.chevron}
            ripple={false}
          >
            Account Menu
          </Dropdown.Button>
        </Navbar.Item>
        <Dropdown.Menu
          aria-label="Account Menu"
          variant="shadow"
          css={{
            background: awsui.colorBackgroundDropdownItemDefault,
            $$dropdownMenuWidth: "340px",
            $$dropdownItemHeight: "70px",
            "& .nextui-dropdown-item": {
              py: "$4",
              // dropdown item title
              "& .nextui-dropdown-item-content": {
                w: "100%",
                fontWeight: "$semibold",
              },
              '&:hover': {
                background: "$primary",
              },
              '&:active': {
                background: "$primary",
              },
              '&:focus': {
                background: "$primary",
              },
            },
          }}
          onAction={(actionKey) => {
            setAccountContent(actionKey.toString());
          }}
        >
          {accountLinks.map((item) => {
            return (
              <Dropdown.Item
                key={item.ref}
                showFullDescription
                description={item.description}
              >
                {item.label}
              </Dropdown.Item>
            )
          })}
        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}
